import { render, staticRenderFns } from "./ShowRulesTable.vue?vue&type=template&id=2ca96799"
import script from "./ShowRulesTable.vue?vue&type=script&lang=js"
export * from "./ShowRulesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports